import { initial } from 'lodash'

export function concatFilter(items: string[]): string {

    const i18n: any = this.context.i18n.global;

    if(!items.length){
        return null;
    }

    if(items.length === 1){
        return items[0];
    }

    const concatArray = initial(items);
    const lastItem = items[items.length - 1];

    return (concatArray.join(', ') + ` ${i18n.t('core.formatting.conjunction')} ` + lastItem).trim();
}